import { User } from "../../models/User";

// Constants
export const LOAD_PERMIT_REGISTER_USERS_STARTED = "LOAD_PERMIT_REGISTER_USERS_STARTED";
export const LOAD_PERMIT_REGISTER_USERS_SUCCESSFUL = "LOAD_PERMIT_REGISTER_USERS_SUCCESSFUL";
export const LOAD_PERMIT_REGISTER_USERS_FAILED = "LOAD_PERMIT_REGISTER_USERS_FAILED";

// State Type
export interface PermitAssignmentsState {
    loading: boolean;
    permitRegisterUsers: User[];
}

// Action Types
interface LoadPermitRegisterUsersStartedAction {
    type: typeof LOAD_PERMIT_REGISTER_USERS_STARTED;
}

interface LoadPermitRegisterUsersSuccessfulAction {
    type: typeof LOAD_PERMIT_REGISTER_USERS_SUCCESSFUL;
    permitRegisterUsers: User[];
}

interface LoadPermitRegisterUsersFailedAction {
    type: typeof LOAD_PERMIT_REGISTER_USERS_FAILED;
    error: Error;
}

export type PermitAssignmentsActionTypes =
    | LoadPermitRegisterUsersStartedAction
    | LoadPermitRegisterUsersSuccessfulAction
    | LoadPermitRegisterUsersFailedAction;
